module.exports = __webpack_public_path__ + "img/logo.6c8a0093.png";